<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentTimeSheet /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentTimeSheet from '@/components/worker/dashboard/modules/timesheet/ContentTimeSheet.vue'

export default 
{
  name: 'TimeSheet',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentTimeSheet
  }
}
</script>
<style>


</style>